import React from "react";
import { showErrorModal, showInfoModal } from "../../../modals";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ThanksForYourPurchase from "../../../images/thanks-for-your-purchase.svg";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/sr';
import { getCurrentLanguageTexts } from "../../../constants/seasonPassPersonalInfoLangs";
import { getCustomURLs } from "../../../helpers/getCustomURLs";
import { getRegion } from "../../../helpers/getRegion";

const MySwal = withReactContent(swal);


let paymentStatus = -1;
export const handleOrderStatus = ({
    status,
    orderId,
    buyerEmail,
    additionalPaymentStatus,
    paymentDate,
    authCode,
    buyMoreUrl,
    showConfirmButton = true,
    reloadData = null }) => {

    if (status === 5 && reloadData != null) {
        setTimeout(() => {
            reloadData();
        }, 4000);
    }

    if (status === paymentStatus)
    {
        return;
    }
    else
    {
        paymentStatus = status;
    }

    switch (status) {
        case 0:
            break;
        case 1:
            showSuccessPaymentModal({
                additionalPaymentStatus,
                paymentDate,
                transactionId: orderId,
                authCode,
                buyMoreUrl,
                showConfirmButton,
            });
            break;
        case 2:
            showErrorPaymentModal({
                additionalPaymentStatus,
                paymentDate,
                transactionId: orderId,
                authCode,
                showConfirmButton: true,
            });
            break;
        case 4:
            showRefundPaymentModal({ transactionId: orderId });
            break;
        case 5:
            showProcessingPaymentModal({ transactionId: orderId });
            break;
        default:
            break;
    }
}

export const showSuccessPaymentModal = (
    {
        buyerEmail,
        additionalPaymentStatus,
        paymentDate,
        transactionId,
        authCode,
        buyMoreUrl,
        showConfirmButton = true,
        isCustomTheme = true
    }) => {

    const txt = getCurrentLanguageTexts();
    moment.locale('sr');
    const { theme } = getRegion();

    if (theme === 'france') {
        moment.locale('fr');
    }

    let customClass = '';

    if (isCustomTheme) {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme";
    } else {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal"
    }

    MySwal.fire({
        html: (
            <div className="season-pass-info-modal">
                <div className="season-pass-info-modal__body">
                    <h3>{txt.sellPageModals["Thanks for Your Purchase!"]}</h3>
                    <img src={ThanksForYourPurchase} alt="Thanks for Your Purchase!" />
                    <p>{txt.sellPageModals["We will send all the details to your inbox"]}(<b>{buyerEmail}</b>){txt.sellPageModals[" and look forward to meeting you"]}</p>
                    <p className="season-pass-info-modal__additionalText">
                        (
                            {txt.sellPageModals["Payment Status: "]} {additionalPaymentStatus || 'null'},
                        {txt.sellPageModals["Payment Date: "]} {moment(paymentDate).format("DD MMMM YYYY HH:mm")},
                        {txt.sellPageModals["Transaction Id: "]} {transactionId || 'null'}, {txt.sellPageModals["Auth Code: "]} {authCode || 'null'})
                    </p>
                </div>
            </div>
        ),
        width: "900px",
        allowEscapeKey: false,
        padding: "0px 0px 48px 0px",
        customClass: customClass,
        allowOutsideClick: false,
        allowEnterKey: false,
        showConfirmButton: showConfirmButton,
        confirmButtonText: txt.sellPageModals["Buy More"],
    }).then((result) => {
        if (result.value && !!buyMoreUrl) {
            window.location.href = getCustomURLs().PUBLIC_URL + buyMoreUrl;
        }
    })

    /* showInfoModal({
        image: ThanksForYourPurchase,
        title: "Thanks for Your Purchase!",
        text: `We will send all the details to your inbox (${buyerEmail}) and look forward to meeting you`,
        additionalText: `(Payment Status: ${additionalPaymentStatus
            }, Payment Date: ${moment(paymentDate).format(
                "DD MMMM YYYY HH:mm"
            )}, Transaction Id: ${transactionId}, Auth Code: ${authCode
            })`,
        customClass:
            "seasonpass__modal_info seasonpass__modal partizan-info-modal",
    }); */
}

export const showErrorPaymentModal = ({
    additionalPaymentStatus,
    paymentDate,
    transactionId,
    authCode,
    isCustomTheme = true,
}) => {
    const txt = getCurrentLanguageTexts();

    let customClass = '';

    if (isCustomTheme) {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme";
    } else {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal"
    }

    showErrorModal({
        text: txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass: customClass,
        additionalText: `(${txt.sellPageModals["Payment Status: "]}${additionalPaymentStatus
            }, ${txt.sellPageModals["Payment Date: "]}${moment(paymentDate).format(
                "DD MMMM YYYY HH:mm"
            )}, ${txt.sellPageModals["Transaction Id: "]}${transactionId}, ${txt.sellPageModals["Auth Code: "]}${authCode
            })`,
    });
}

export const showProcessingPaymentModal = ({
    transactionId,
    isCustomTheme = true,
}) => {
    const txt = getCurrentLanguageTexts();

    let customClass = '';

    if (isCustomTheme) {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme";
    } else {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal"
    }

    showInfoModal({
        image: ThanksForYourPurchase,
        text: txt.sellPageModals["Your transaction is in processing"],
        customClass: customClass,
        additionalText: `(${txt.sellPageModals["Transaction Id: "]}${transactionId})`,
    });
}

export const showRefundPaymentModal = ({
    transactionId,
    isCustomTheme = true,
}) => {
    const txt = getCurrentLanguageTexts();

    let customClass = '';

    if (isCustomTheme) {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme";
    } else {
      customClass = "seasonpass__modal_info seasonpass__modal partizan-info-modal"
    }

    showErrorModal({
        text: txt.sellPageModals["Transaction was refunded"],
        customClass: customClass,
        additionalText: `(${txt.sellPageModals["Transaction Id: "]}${transactionId})`,
    });
}